{
	"actions": {
		"cancel": "Cancel",
		"end_every_session": "End every session of this person",
		"end_session": "End this session",
		"open_menu": "Open the actions menu",
		"sign_out": "Sign out"
	},
	"columns": {
		"actions": "Actions",
		"address": "Address",
		"device": "Device",
		"last_activity": "Last activity",
		"person": "Person",
		"started_at": "Started"
	},
	"empty": {
		"description": "The open accesses of the people in your organization appear here, with the device and the address they come from.",
		"title": "No active sessions"
	},
	"end": {
		"all_confirm": "End every session",
		"all_description": "Every open access of theirs closes straight away, on every device. They have to sign in again to come back.",
		"all_title": "End every session of this person?",
		"channel_closed": "The realtime connection was closed.",
		"channel_pending": "The realtime server did not answer. The retry is queued: until it lands, the connection that is already open keeps receiving.",
		"channel_pending_window_one": "The realtime server did not answer. The retry is queued: if it never lands, the connection that is already open can keep receiving for at most {{count}} minute.",
		"channel_pending_window_other": "The realtime server did not answer. The retry is queued: if it never lands, the connection that is already open can keep receiving for at most {{count}} minutes.",
		"done_one": "{{count}} session ended.",
		"done_other": "{{count}} sessions ended.",
		"one_confirm": "End the session",
		"one_description": "The access from this device closes straight away. Whoever was using it has to sign in again to come back.",
		"one_title": "End this session?",
		"own_access_description": "The session you are using right now closes as well, and you go back to the sign-in page.",
		"own_access_title": "This person is you",
		"pending": "Ending…"
	},
	"no_value": "Not available",
	"page_title": "Active sessions",
	"person": {
		"this_session": "This session",
		"you": "You"
	},
	"sign_out": {
		"confirm": "Sign out",
		"description": "This is the session you are using right now. Signing out takes you back to the sign-in page, and your other sessions stay open.",
		"pending": "Signing out…",
		"title": "Sign out?"
	},
	"total_one": "{{count}} active session",
	"total_other": "{{count}} active sessions"
}
